import React, { useState } from 'react';
import {
  Button,
  LinearProgress,
  Stack,
} from '@mui/material';
import { dictionary } from './dictionary/dictionary';
import { general_props } from './general_props/general_props';
import { HandleFetchReceptions } from './logic/HandleFetchReceptions';
import FileUploader from '../FileUploader/FileUploader';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { useNavigate } from 'react-router-dom';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';

const Details_Operations = ({ details, setReceptions }) => {
  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop

  const { uploadReceipt, receiptList } = dictionary();
  const [enableUploader, setEnableUploader] =
    useState(false);

  const [enableLoading, setEnableLoading] = useState(false);

  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Stack gap=".3em" direction="row">
        <Button
          disabled={enableLoading || !details?.Bedehkar}
          variant="contained"
          {...general_props}
          onClick={() => {
            // setEnableUploader(true);
            sessionStorage.removeItem('temp_ureceit');
            sessionStorage.setItem(
              'temp_ureceit',
              JSON.stringify(details)
            );
            navigate({
              pathname:
                screenWidth > 1024
                  ? '/main/UploadReceipt'
                  : '/UploadReceipt',
            });
          }}
          sx={{
            color: `${themeColors.ColorPrimary} !important`,
          }}
        >
          {uploadReceipt}
        </Button>
        <Button
          disabled={enableLoading}
          variant="contained"
          {...general_props}
          onClick={() => {
            HandleFetchReceptions(
              details?.IdTestimontial,
              setReceptions
            );
          }}
          sx={{
            color: `${themeColors.ColorPrimary} !important`,
          }}
        >
          {receiptList}
        </Button>

        {/* <FileUploader
          enableUploader={enableUploader}
          setEnableUploader={setEnableUploader}
          IdTestimontial={details?.IdTestimontial}
          setReceptions={setReceptions}
          setEnableLoading={setEnableLoading}
          enableLoading={enableLoading}
        /> */}
      </Stack>
      {enableUploader ? <LinearProgress /> : <></>}
    </React.Fragment>
  );
};

export default Details_Operations;
